import React, { Component } from 'react'
import moment from "moment"
import { AgGridReact } from "ag-grid-react"
import { session } from "services/session"
import { Button, Form } from "semantic-ui-react";
import DatePicker from 'react-datepicker'
import toastr from 'toastr'
import ApiHelper from "services/api-helper";
import KhaiBaoCongTacTaoMoi from 'components/khai-bao-cong-tac/tao-moi-modal';

class KhaiBaoCongTac extends Component {
  state = {
    rowData: [],
    columnDefs: [
      { checkboxSelection: true, minWidth: 40, maxWidth: 40 },
      {
        headerName: "#",
        minWidth: 50,
        maxWidth: 50,
        suppressSorting: true,
        cellRenderer: function (params) {
          return params.rowIndex + 1;
        }
      },
      {
        headerName: "Từ ngày", field: "TuNgay",
        valueFormatter: function (data) {
          return moment(data.value).format('DD/MM/YYYY')
        }
      },
      {
        headerName: "Đến ngày", field: "DenNgay",
        valueFormatter: function (data) {
          return moment(data.value).format('DD/MM/YYYY')
        }
      },
      {
        headerName: "Buổi", field: "Buoi",
        cellRenderer: function (data) {
          if (data.value === 1)
            return "Cả ngày"
          else if (data.value === 2)
            return "Sáng"
          else if (data.value === 3)
            return "Chiều"
        }
      },
      { headerName: "Số ngày", field: "SoNgay" },
      { headerName: "Nội dung", field: "NoiDung" },
      { headerName: "Địa điểm", field: "DiaDiem" },
      {
        headerName: "Trạng thái", field: "TrangThai",
        headerClass: 'ag-header-center',
        cellClass: 'text-center',
        cellRenderer: function (data) {
          if (data.value === -1)
            return '<img src="img/InfoSmall.jpg" title="Chờ xét" />'
          else if (data.value === 1)
            return `<img src="img/TT_yes.png" title="Chấp nhận${data.data.NgayDuyet && ' lúc ' + moment.utc(data.data.NgayDuyet).format('HH:mm DD/MM')}" />`
          else if (data.value === 0)
            return '<img src="img/TT_no.png" title="Không chấp nhận" />'
        }
      }
    ],
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
    openModal: false
  }
  updateModalState = (openModal) => {
    this.setState({ openModal })
    if (!openModal) this.getData()
  }
  getData = () => {
    ApiHelper.GetJson('api/getDanhSachKhaiBaoCongTac', {
      IdNhanVien: session.NhanVienId,
      TuNgay: this.state.startDate,
      DenNgay: this.state.endDate
    }).then(res => {
      this.setState({ rowData: res })
      this.autoSizeAll()
    }, error => {
      toastr.error(error)
    })
  }
  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi
    this.getData()
  }
  autoSizeAll() {
    this.gridApi.sizeColumnsToFit()
    var widthAfterSizeColsToFit = this.gridColumnApi.getAllColumns().map(column => column.getActualWidth()).reduce((a, b) => a + b, 0)
    this.gridColumnApi.autoSizeAllColumns()
    var widthAfterAutoSize = this.gridColumnApi.getAllColumns().map(column => column.getActualWidth()).reduce((a, b) => a + b, 0)
    if (widthAfterSizeColsToFit > widthAfterAutoSize) {
      this.gridApi.sizeColumnsToFit()
    }
  }
  xoa = () => {
    const selectedNodes = this.gridApi.getSelectedNodes().map(q => q.data)
    if (selectedNodes.length < 1) {
      toastr.error('Chọn 1 dòng')
      return
    }
    if (selectedNodes.length > 1) {
      toastr.error('Chọn 1 dòng thôi')
      return
    }
    if (!window.confirm('Bạn chắc chắn muốn xóa?'))
      return
    ApiHelper.PostJson('api/xoaKhaiBaoCongTac', {
      Oid: selectedNodes[0].Oid
    }).then(res => {
      if (res === 1) {
        toastr.success('Đã xóa!');
        this.getData();
      }
      else if (res === 2) {
        toastr.warning('Đơn đã được duyệt!');
      }
    }, error => {
      toastr.error(error)
    })
  }
  handleChange = (_ref) => {
    var startDate = _ref.startDate || this.state.startDate
    var endDate = _ref.endDate || this.state.endDate

    if (startDate.isAfter(endDate)) {
      _ref.startDate && (endDate = startDate)
      _ref.endDate && (startDate = endDate)
    }

    this.setState({ startDate: startDate, endDate: endDate })
  }
  handleChangeStart = (startDate) => {
    return this.handleChange({ startDate })
  }
  handleChangeEnd = (endDate) => {
    return this.handleChange({ endDate })
  }
  render() {
    return (
      <div>
        <Form>
          <Form.Group className="ui center aligned grid">
            <Form.Field>
              <Button onClick={() => this.updateModalState(true)} positive>Tạo mới</Button>
            </Form.Field>
            <Form.Field>
              <Button onClick={this.xoa} negative>Xóa</Button>
            </Form.Field>
          </Form.Group>
          <Form.Group className="ui center aligned grid">
            <Form.Field>
              <DatePicker
                selected={this.state.startDate}
                selectsStart
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.handleChangeStart}
                dateFormat="DD/MM/YYYY"
                placeholderText="Từ ngày"
              />
            </Form.Field>
            <Form.Field>
              <DatePicker
                selected={this.state.endDate}
                selectsEnd
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.handleChangeEnd}
                dateFormat="DD/MM/YYYY"
                placeholderText="Đến ngày"
              />
            </Form.Field>
            <Form.Field>
              <Button onClick={this.getData} color="twitter">Tìm</Button>
            </Form.Field>
          </Form.Group>
        </Form>
        <div className="ag-theme-balham" style={{ height: '500px', marginBottom: "20px" }}>
          <AgGridReact
            enableSorting={true}
            rowSelection="single"
            enableFilter={true}
            enableColResize={true}
            suppressColumnVirtualisation={true}
            onGridReady={this.onGridReady}
            columnDefs={this.state.columnDefs}
            rowData={this.state.rowData}>
          </AgGridReact>
        </div>
        {this.state.openModal &&
          <KhaiBaoCongTacTaoMoi openModal={this.state.openModal} closeModal={() => this.updateModalState(false)} />
        }
      </div>
    )
  }
}

export default KhaiBaoCongTac


// WEBPACK FOOTER //
// ./src/components/khai-bao-cong-tac/index.jsx